import { TFunction } from 'i18next'

import { sogUnlocodeRoutes } from '@dfds-pax/utils'

import { sogCutoverDates } from './sog-cutover-dates'

export const isSogRoute = (routeCode: string, outboundDate?: string): boolean => {
  if (!sogUnlocodeRoutes.includes(routeCode)) return false

  const cutoverDate = sogCutoverDates[routeCode]
  if (cutoverDate) {
    // Date-based cutover: on/after cutover date → PAX-OB (false); before → FRS (true)
    return !(outboundDate && outboundDate >= cutoverDate)
  }
  // No cutover date: treat as PAX-OB
  return false
}

export const mapToCurrencyToContentfulResource = (currencyId: string, t: TFunction<'translation', undefined>): string => {
  if (currencyId === 'EUR') return t('EURO')
  else if (currencyId === 'MAD') return t('DIRHAM')
  else return t('EURO')
}
